import { PromotionEntityType, SubBrokerType } from '../../shared/generated';
export var judgeIsPromotionQuotePolicy = function judgeIsPromotionQuotePolicy(promotionInfo) {
  var _ref = promotionInfo || {},
      promotionType = _ref.promotionType;

  return [PromotionEntityType.PARTNER_PROMOTION, PromotionEntityType.BROKER_PROMOTION].includes(promotionType);
};
export var judgeIsPartnerQuotePolicy = function judgeIsPartnerQuotePolicy(promotionInfo) {
  var _ref2 = promotionInfo || {},
      promotionType = _ref2.promotionType,
      subBrokerType = _ref2.subBrokerType;

  return [PromotionEntityType.PARTNER_PROMOTION].includes(promotionType) || subBrokerType === SubBrokerType.PARTNER;
};